import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import type { Assets } from '@Utils/AssetsStore';

function getLetterSpacing(troikaTextProps: CardTextProps): number {
  // letter spacing in CardTextProps for troika-text is a % multiplier of base font size.
  // Typically set to 0.03.
  // But in HTML space is absolute pixes, so we need to convert it to pixels.

  const { letterSpacing = 0, fontSize = 0 } = troikaTextProps;

  return letterSpacing * fontSize;
}

export function convertToHtmlTextProps(
  cardProps: CardTextProps
): CardTextProps & { fontFamily?: Assets } {
  return {
    ...cardProps,
    letterSpacing: getLetterSpacing(cardProps),
    lineHeight: cardProps.lineHeight ?? 1,
    fontFamily: cardProps.fontAsset,
  };
}
